/**
 * Display amounts with a neutral "$" prefix — no FX; not labelled as USD or CAD.
 */
export function formatDollars(
  amount: number | null | undefined,
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number }
): string {
  const min = options?.minimumFractionDigits ?? 2;
  const max = options?.maximumFractionDigits ?? 2;
  const n =
    amount != null && typeof amount === 'number' && Number.isFinite(amount) ? amount : 0;
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  }).format(n);
  return `$${formatted}`;
}
